export enum Locale {
  English = 'en',
  SimplifiedChinese = 'cn',
  Turkish = 'tr',
  Spanish = 'es',
  French = 'fr',
  Portuguese = 'pt',
  Japanese = 'jp',
  SouthKorean = 'kr',
}
